<div>
    <span> {{message}}  </span>
    <mat-spinner diameter="80"></mat-spinner>
</div>